// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:19
import { MapLayer_abstract } from './../abstract/SagaBase/MapLayer_abstract';
export class MapLayer extends MapLayer_abstract {}
